import React from 'react';

import {
  FormControl,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  VStack,
} from '@chakra-ui/react';

import {Controller, useFormContext} from 'react-hook-form';

import {QuestionProps} from './question';

export function RadioButtonQuestion(props: Readonly<QuestionProps>) {
  const {question} = props;
  const {control} = useFormContext();

  const options = question.options.map(it => (
    <Radio key={it.id} value={it.id} w='100%'>
      {it.value}
    </Radio>
  ));

  return (
    <FormControl isRequired={question.isRequired}>
      <FormLabel>{question.title}</FormLabel>
      <Controller
        control={control}
        name={question.id}
        render={({field: {onChange, value}}) => (
          <RadioGroup onChange={onChange} value={value}>
            <VStack justifyContent='flex-start'>{options}</VStack>
          </RadioGroup>
        )}
      />
      <FormHelperText>{question.description}</FormHelperText>
    </FormControl>
  );
}
